import { render, staticRenderFns } from "./Rodape.vue?vue&type=template&id=6dfeb3e3&scoped=true&"
import script from "./Rodape.vue?vue&type=script&lang=js&"
export * from "./Rodape.vue?vue&type=script&lang=js&"
import style0 from "./Rodape.vue?vue&type=style&index=0&id=6dfeb3e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfeb3e3",
  null
  
)

export default component.exports